import { useEffect } from 'react'
import { useAuth } from '@structural-climbing/auth'

export function LogoutPage() {
  const { logout } = useAuth()

  useEffect(() => {
    logout({ logoutParams: { returnTo: window.location.origin } })
  }, [logout])

  return null
}
